<template>
<div>
    <draggable style="width:100%" v-model="localItems" :options="{ animation: 350, group:'items', handle: '.draggable-handle'}" @end="afterDrag">
        <div v-for="item in localItems" :key="item.meta.key" class="list-tile clickable hoverable" :data-order="item.order" @click="itemClicked(item)">
            <div style="float:right;margin-top:-2px;margin-right:-15px" @click.stop>
                <v-menu offset-y left>
                    <template v-slot:activator="{ on }">
                    <v-icon v-on="on" class="draggable-handle" style="color:#ddd">more_vert</v-icon>
                    </template>
                    <v-list>
                        <v-list-item @click="editItem(item)">
                            <v-list-item-title>Edit</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="addItem">
                            <v-list-item-title>Add New</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </div>
            <slot v-bind="item">    
                 {{item.name}}
            </slot>
        </div>   
    </draggable>
    <AdvancedDialog :record="editDialog.record" :settings="editDialog.settings" :fields="fields" @save="saveRecord" @delete="deleteRecord"/>
</div>
</template>

<script>
import DataHelpers from '../helpers/DataHelpers'
import draggable from 'vuedraggable'
import NiceData from '../data/NiceData';
import OrderHelpers from '../helpers/OrderHelpers';
import AdvancedDialog from '../ui-elements/AdvancedDialog';

export default {
    data() {
        return {
            localItems: [],
            fields: [
                {name: 'name', title: 'Name', type: 'Text'},
                {name: 'type', title: 'Type', type: 'List', options: 'Document, Group'},
            ],
            editDialog: {
                record: {},
                settings: {
                    visible: false
                }
            }
        }
    },



    components: {
        draggable,
        AdvancedDialog,
    },
    
    props: {
        dataRef: Object,
        items: Array
    },

    computed: {

    },

    methods: {
        afterDrag(e) {
            console.log('dragged', e)
            let newItem = this.localItems[e.newIndex]
            newItem.order = OrderHelpers.getAverageOrder(e)
            NiceData.saveItem(newItem)
        },
        editItem(item) {
            this.editDialog.record = {...item}
            this.editDialog.settings.visible = true
        },
        addItem() {
            let item = {
                meta: {
                    key: DataHelpers.getKey(),
                    path: this.dataRef.toString().split('/').splice(3).join('/'),
                    savePosition: 'top'
                }
            }
            this.editItem(item)
    
        },
        saveRecord(record) {
            NiceData.saveItem(record)
        },

        deleteRecord(record) {
            NiceData.deleteItem(record)
            this.editDialog.settings.visible = false
        },

        itemClicked(item) {
            this.$emit('click', item)
        }
    },

    watch: {
        'items': {
            handler: function(newVal, oldVal) {
                
                if(newVal && newVal.length)
                    this.localItems = newVal
                // else
                //     this.dataRef.orderByChild('order').on('value', snap => {
                //         this.localItems = NiceData.arrayFromSnapshot(snap)
                //     })
            },
            immediate: true
        }
    },

    created() {      

 
    }
}
</script>

<style scoped>

   
</style>




// WEBPACK FOOTER //
// AdvancedList.vue?1576c7b7